import { render } from "./FooterSihusel.vue?vue&type=template&id=1cfc0467"
import script from "./FooterSihusel.vue?vue&type=script&lang=js"
export * from "./FooterSihusel.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__